import { CustomerData } from '@/hooks/shopify-hooks/customerData';
import { useIsAccessTokenValid } from '@/hooks/shopify-hooks/useShopifyUtils';
import { _CSR_ACCESS_TOKEN, _CSR_IS_B2b } from '@/const/shopifyConst.js';
import { useSetStorage, useGetStorage } from '@/hooks/common/useStorage';

export const useCustomer = () => {
  // const isB2B = localStorage.getItem(_CSR_IS_B2b);
  // const accessToken = JSON.parse(localStorage.getItem(_CSR_ACCESS_TOKEN));
  const isB2B = useGetStorage(_CSR_IS_B2b);
  const accessToken = useGetStorage(_CSR_ACCESS_TOKEN);
  if (!useIsAccessTokenValid(accessToken)) {
    return;
  }
  
  const getCustomer = async () => {
    try {
      const customerData = new CustomerData(isB2B);
      const customerResponse = await customerData.getCustomer(accessToken.accessToken);
      return customerResponse;
    } catch(e) {
      console.error(e);
    }
  }
  
  // 参数customerUpdateInput {firstName: '', lastName： '', email: '', password: '', acceptsMarketing: ''} 改动什么传什么即可
  // validateParams 极验参数
  const updateCustomer = async(customerUpdateInput,validateParams,customOptions) => {
    try {
      const customerData = new CustomerData(isB2B);
      console.log('acceptsMarketing---- updateCustomer',customerUpdateInput)
      const response = await customerData.updateCustomer(customerUpdateInput, accessToken.accessToken,validateParams,customOptions);
      if (response.customer) {
        // customer = response.customer;
        // 若更改到密码，就会更换accessToken
        if (response.customerAccessToken && response.customerAccessToken !== accessToken) {
          // localStorage.setItem(_CSR_ACCESS_TOKEN, JSON.stringify(response.customerAccessToken));
          useSetStorage(_CSR_ACCESS_TOKEN, response.customerAccessToken);
        }
      }
      return response;
    } catch(e) {
      console.error(e);
    }
  
  }

  const addBirth = async(customerUpdateInput,validateParams,customOptions) => {
    try {
      const customerData = new CustomerData(isB2B);
      console.log('acceptsMarketing---- updateCustomer',customerUpdateInput)
      const response = await customerData.addBirth(customerUpdateInput, accessToken.accessToken,validateParams,customOptions);
      return response;
    } catch(e) {
      console.error(e);
    }
  
  }

  const addAddress = async (mailingAddressInput, isDefault) => {
    try {
      const customerData = new CustomerData(isB2B);
      const response = await customerData.addAddress(mailingAddressInput, accessToken.accessToken, isDefault);
      return response;
    } catch(e) {
      console.error(e);
    }
  }
  
  // 参数mailingAddressInput要传address对象{address1, city, country: 'US', firstName, lastName, phone, province: 'AL', zip}
  const updateAddress = async (mailingAddressInput, addressId, isDefault) => {
    try {
      const customerData = new CustomerData(isB2B);
      const response = await customerData.updateAddress(mailingAddressInput, addressId, isDefault, accessToken.accessToken);
      return response;
    } catch(e) {
      console.error(e);
    }
  }

  const deleteAddress = async (addressId) => {
    try {
      const customerData = new CustomerData(isB2B);
      const response = await customerData.deleteAddress(addressId, accessToken.accessToken);
      return response;
    } catch(e) {
      console.error(e);
    }
  }

  const setDefaultAddress = async (addressId) => {
    try {
      const customerData = new CustomerData(isB2B);
      const response = await customerData.updateDefaultAddress(addressId, accessToken.accessToken);
      return response;
    } catch (e) {
        console.error(e);
    }
  }


  return {
      getCustomer: getCustomer,
      updateCustomer: updateCustomer,
      addBirth:addBirth,
      addAddress: addAddress,
      updateAddress: updateAddress,
      deleteAddress: deleteAddress,
      setDefaultAddress: setDefaultAddress,
  }
}
